import { FC } from 'react';
import Button from 'v3/common/components/Button';
import PortalToTarget from 'v3/common/components/PortalToTarget';
import UserInput from 'v3/common/components/UserInput';
import { BrokerSpecificComponentsProps } from 'v3/pages/LandingPage/Default/BannerSection/UserAuth/LoginModal/types.type';

const PhilipCapital: FC<BrokerSpecificComponentsProps> = ({
  userConfigs,
  brokerSpecificHandles,
  switchPage,
}) => {
  const { validateClientId, updatePartialConfigs, reDirectPage, isMobile } = brokerSpecificHandles;
  const {
    clientId,
    isLoading,
    password,
    isClientValidated,
    shouldShowApiKey,
    apiKey,
    otp,
    isValidForm,
    selectedBrokerConfig,
  } = userConfigs;
  const broker = selectedBrokerConfig?.id;

  return (
    <form
      id={`${broker}-form`}
      onSubmit={(e) => {
        e.preventDefault();
        return isClientValidated ? reDirectPage({ otp: otp }, false) : validateClientId();
      }}
    >
      <UserInput
        autoFocus={!isMobile}
        labelValue="Client Id"
        id={`${broker}-client-id`}
        value={clientId}
        isDisabled={isClientValidated}
        placeholder="Enter Client Id"
        onHandleChange={(value) => updatePartialConfigs({ clientId: value })}
      />

      {isClientValidated && (
        <>
          <UserInput
            labelValue="Password"
            id={`${broker}-password`}
            type="password"
            value={password}
            placeholder="Enter Password"
            onHandleChange={(value) => updatePartialConfigs({ password: value })}
          />
          <UserInput
            labelValue="TOTP/OTP/DOB/PAN"
            id={`${broker}-totp`}
            value={otp}
            placeholder="Enter TOTP/OTP/DOB/PAN"
            onHandleChange={(value) => updatePartialConfigs({ otp: value })}
          />
        </>
      )}

      {!shouldShowApiKey && isClientValidated && (
        <button type="button" onClick={() => updatePartialConfigs({ apiKey: '', shouldShowApiKey: true })}>
          <i className="fa-regular fa-gear fa-spin" />
          Change api?
        </button>
      )}

      {shouldShowApiKey && (
        <>
          <UserInput
            labelValue="API Key (One-time registration)"
            id={`${broker}-api-key`}
            value={apiKey}
            placeholder="Enter API Key"
            onHandleChange={(value) => updatePartialConfigs({ apiKey: value })}
          />
          <button type="button" onClick={() => switchPage()}>
            <i className="fa-regular fa-gear fa-spin" />
            How to generate API?
          </button>
        </>
      )}

      {!isValidForm && <div className="invalid-feedback d-block">Please provide the details</div>}

      <PortalToTarget targetClassName="login-modal__footer" allowForWeb>
        <Button form={`${broker}-form`} isLoading={isLoading} type="submit">
          {isClientValidated ? 'Login' : 'Validate'}
        </Button>
      </PortalToTarget>
    </form>
  );
};

export default PhilipCapital;
